import { MdStop } from "react-icons/md";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

interface SpeakingIndicatorProps {
  isSpeaking: boolean;
  onStop: () => void;
}

const SpeakingIndicator = ({ isSpeaking, onStop }: SpeakingIndicatorProps) => {
  const { t } = useTranslation();
  if (!isSpeaking) return null;

  return (
    <div className="inline-flex items-center gap-2">
      <span className="text-xs text-gray-500">{t("voice.speakingMessage")}</span>
      <Tooltip title={t("voice.stopSpeaking")} arrow>
        <button
          type="button"
          onClick={onStop}
          aria-label={t("voice.stopSpeaking")}
          className="inline-flex items-center justify-center w-6 h-6 rounded-md bg-green-50 text-green-700 border border-green-200 hover:bg-green-100 transition-colors animate-pulse"
        >
          <MdStop size={14} />
        </button>
      </Tooltip>
    </div>
  );
};

export default SpeakingIndicator;
